var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTemplate(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2582_14300)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.05882 1.17188C7.70857 1.17188 8.2353 1.6986 8.2353 2.34835V17.6425C8.2353 18.2922 7.70857 18.8189 7.05882 18.8189H1.17647C0.526724 18.8189 0 18.2922 0 17.6425V2.34835C0 1.6986 0.526724 1.17188 1.17647 1.17188H7.05882ZM18.8235 11.7601C19.4733 11.7601 20 12.2868 20 12.9366V17.6425C20 18.2922 19.4733 18.8189 18.8235 18.8189H10.5882C9.93849 18.8189 9.41177 18.2922 9.41177 17.6425V12.9366C9.41177 12.2868 9.93849 11.7601 10.5882 11.7601H18.8235ZM5.88235 3.52482H2.35294V16.466H5.88235V3.52482ZM17.6471 14.1131H11.7647V16.466H17.6471V14.1131ZM18.8235 1.17188C19.4733 1.17188 20 1.6986 20 2.34835V9.40717C20 10.0569 19.4733 10.5836 18.8235 10.5836H10.5882C9.93849 10.5836 9.41177 10.0569 9.41177 9.40717V2.34835C9.41177 1.6986 9.93849 1.17188 10.5882 1.17188H18.8235ZM17.6471 3.52482H11.7647V8.2307H17.6471V3.52482Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2582_14300"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "currentColor"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTemplate);
export default __webpack_public_path__ + "static/media/template.29ff5088ccf97ebb6b2e6c541fc332f0.svg";
export { ForwardRef as ReactComponent };